function toggleTab() {
	$(".tabContent").hide();
	$(".tabContent:first").show();

	$(".tabTitle li").click(function() {
		$(".tabContent").hide();
		var activeTab = $(this).attr("rel");
		$("#" + activeTab).fadeIn();
		$(".tabTitle li").removeClass("active");
		$(this).addClass("active");
	});
}